<template>
  <div class="calico-deep-search">
    <Modal
      v-if="show"
      header="Deep Search"
      class="calico-deep-search-modal"
      @close="show = false"
    >
      <template #content>
        <CalicoForm
          v-slot="{ field, error }"
          name="businessName"
          label="Business Name"
          rules="required"
        >
          <CalicoField
            v-model="businessName"
            v-bind="field"
            :error="error"
            placeholder="Enter a business name"
          />
        </CalicoForm>

        <CalicoForm
          v-slot="{ field, error }"
          name="street"
          label="Business Street Address"
        >
          <CalicoField
            v-model="street"
            v-bind="field"
            :error="error"
            placeholder="123 Main St"
          />
        </CalicoForm>

        <CalicoForm
          v-slot="{ field, error }"
          name="street2"
          label="Address 2"
        >
          <CalicoField
            v-model="street2"
            v-bind="field"
            :error="error"
            placeholder="Bldg,Sute,Apt,etc."
          />
        </CalicoForm>

        <CalicoForm
          v-slot="{ field, error }"
          name="state"
          label="State"
          rules="required"
        >
          <CalicoDropdown
            v-model="state"
            v-bind="field"
            :error="error"
            placeholder="Select..."
          >
            <CalicoDropdownMenuItem
              v-for="option in states"
              :key="option.value"
              class="calico-option body--medium"
              :value="option.value"
            >
              {{ option.label }}
            </CalicoDropdownMenuItem>
          </CalicoDropdown>
        </CalicoForm>

        <div class="address">
          <CalicoForm
            v-slot="{ field, error }"
            name="city"
            label="City"
            rules="required"
          >
            <CalicoField
              v-model="city"
              v-bind="field"
              :error="error"
              placeholder="Enter city"
            />
          </CalicoForm>

          <CalicoForm
            v-slot="{ field, error }"
            name="zip"
            label="Zip"
          >
            <CalicoField
              v-model="zip"
              v-bind="field"
              :error="error"
              :only-numbers="true"
              placeholder="Enter zip"
            />
          </CalicoForm>
        </div>
      </template>

      <template #footer>
        <button
          type="submit"
          class="button-primary"
          @click="search"
        >
          Search
        </button>
      </template>
    </Modal>
    <div class="calico-deep-search-banner">
      <div class="title">
        <i class="bi bi-zoom-in contained-icon-medium" />
        <h3 class="heading--xsmall">
          Deep search
        </h3>
      </div>
      <p class="body--medium">
        Having trouble finding the business in the search results? Provide more details for specific results.
      </p>
      <span style="width: fit-content;">
        <button
          class="button-utility button-utility--small"
          @click="show = true"
        >
          <i class="bi bi-search" />
          Perform Deep Search
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import CalicoField from '@/components/calico/field/index.vue'
import CalicoDropdown from '@/components/calico/dropdown/index.vue'
import CalicoDropdownMenuItem from '@/components/calico/dropdownMenuItem/index.vue'
import CalicoForm from '@/components/pattern/form/index.vue'
import { states } from "@/constants"
import Modal from "@/components/template/modal/index.vue"
import { useForm } from 'vee-validate'

export default {
    name: "CalicoDeepSearchBanner",
    components: {
        CalicoField,
        CalicoForm,
        CalicoDropdown,
        CalicoDropdownMenuItem,
        Modal
    },
    setup() {
        const { validate, values, setFieldValue } = useForm({
            initialValues: {
                businessName: '',
                street: '',
                street2: '',
                state: '',
                city: '',
                zip: '',
            },
        });
        return { validate, values, setFieldValue };
    },
    data() {
        return {
            show: false,
            states,
            page: 1,
            limit: 20,
        }
    },
    methods: {
        async search() {
            const { valid } = await this.validate()
            if (!valid) {
                return
            }
            const params = {
                businessName: this.businessName,
                state: this.state,
                street: this.street,
                street2: this.street2,
                city: this.city,
                zip: this.zip,
                deep: true
            }
            this.$router.push({ path: '/search-results', query: params })
            this.show = false
        }
    }
};
</script>

<style lang="scss">
.calico-deep-search {
    width: 100%;
    .calico-deep-search-modal {
        .content {
            @include inset-space($space-medium);
            @include stack-space($space-large);
            .address {
                @include inline-space($space-medium);
            }
        }
        div.footer {
            @include inset-space($space-large);
        }
    }
    .calico-deep-search-banner {
        @include inset-space($space-medium);
        @include stack-space($space-medium);
        border: 2px solid $color-border-primary;
        border-radius: $radius-large;
        width: 100%;
        .title {
            @include inline-space($space-medium);
            align-items: center;

            .bi {
                background-color: $color-cyan;
                border: 0;
            }
        }
    }
}
</style>
